export const fieldsGridStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
  gap: '16px',
  width: '100%',
};

export const fieldItemStyles = {
  width: '100%',
};
